module.exports = __webpack_public_path__ + "images/tabs/contacts-on.png";